import React from 'react';
import { 
  Sparkles, Cpu, Code, Brush, PaintBucket, 
  UsersRound, Gamepad2
} from 'lucide-react';
import Container from './Container';
import FeatureCard from './FeatureCard';

const Features: React.FC = () => {
  const features = [
    {
      icon: <Sparkles className="h-6 w-6" />,
      title: 'AI Game Generator',
      description: 'Describe your game idea in natural language and let AI generate a playable prototype instantly.'
    },
    {
      icon: <Brush className="h-6 w-6" />,
      title: 'No-Code Editor',
      description: 'Drag and drop elements to build your game without writing a single line of code.'
    },
    {
      icon: <Code className="h-6 w-6" />,
      title: 'Developer Tools',
      description: 'Advanced tools and APIs for experienced developers to extend and customize games.'
    },
    {
      icon: <PaintBucket className="h-6 w-6" />,
      title: 'Asset Creation',
      description: 'Generate game assets, characters, environments, and animations with AI assistance.'
    },
    {
      icon: <UsersRound className="h-6 w-6" />,
      title: 'Community Sharing',
      description: 'Share your games with the community, get feedback, and collaborate with others.'
    },
    {
      icon: <Cpu className="h-6 w-6" />,
      title: 'Cloud Publishing',
      description: 'Publish your games directly to the web, mobile, or desktop platforms with one click.'
    }
  ];
  
  return (
    <section id="features" className="bg-background py-16 md:py-24">
      <Container>
        <div className="mx-auto mb-16 max-w-2xl text-center">
          <div className="inline-flex items-center rounded-full bg-secondary/10 px-3 py-1 text-sm font-medium text-secondary ring-1 ring-inset ring-secondary/20 mb-4">
            <Gamepad2 size={16} className="mr-1" />
            <span>Game Creation Features</span>
          </div>
          <h2 className="mb-4 text-3xl font-bold sm:text-4xl md:text-5xl">
            Powerful Tools for Game Creators
          </h2>
          <p className="text-lg text-muted-foreground">
            From AI-powered generation to no-code tools and professional development kits, Wizantix.games offers everything you need to bring your game ideas to life.
          </p>
        </div>
        
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Features;